import React from 'react';
import dataProvider from './../../../common/dataProvider';
import Groups from './rewritegroups';
import Items from './rewriteitems';
import {Route, Routes} from 'react-router-dom';

class Index extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: {data:[], metadata: []}
        }
    }
    componentDidMount() {
        this.loadFromServer();
    }
    loadFromServer() {
        const url = `/admin/carriers/settings/rewrite`;
        dataProvider.getList(url, {}).then(
            response => 
            this.setState({
                loading: false,
                data: response.data
            })
        );
    }
    render() {
        return (
            <div>
                <Routes>
                    <Route 
                        path="/carriers/settings/rewrite" 
                        exact 
                        render={
                            (props) => <Groups {...props} data={this.state.data} childProps={this.props.childProps}/>
                        } />
                    <Route 
                        path="/carriers/settings/rewrite/:group_id" 
                        exact 
                        render={
                            (props) => <Items {...props} data={this.state.data} childProps={this.props.childProps}/>
                        } />
                </Routes>
            </div>
        )
    }
}

export default Index;